
import { combineReducers } from "redux";
import syncs from "./syncs";

export default combineReducers({
  syncs: syncs
});